// PR-F2 — card-surcharge config TanStack Query hooks. The list read registers
// under the co-located key factory; the per-state update mutation invalidates
// the list so the grid reflects the saved row. Toasts + ApiError rendering
// happen in the calling page.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  cardSurchargeApi,
  type UpdateCardSurchargeConfigRequest,
} from "@/api/portfolioAdmin/cardSurchargeApi";
import { cardSurchargeKeys } from "@/hooks/portfolioAdmin/cardSurchargeKeys";

export function useCardSurchargeConfigs() {
  return useQuery({
    queryKey: cardSurchargeKeys.list(),
    queryFn: () => cardSurchargeApi.list(),
  });
}

export function useUpdateCardSurcharge() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: {
      stateCode: string;
      body: UpdateCardSurchargeConfigRequest;
    }) => cardSurchargeApi.update(vars.stateCode, vars.body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: cardSurchargeKeys.list() });
    },
  });
}
